<template>
  <div :class="`${!manager ? 'content content-fixed content-profile' : ''}`">
    <div class="container pd-x-0 pd-lg-x-10 pd-xl-x-0">
      <div class="media d-block d-lg-flex">
        <div v-if="!manager" class="profile-sidebar pd-lg-r-25">
          <div class="row">
            <div class="col-sm-3 col-md-2 col-lg">
              <simple-uploader
                v-if="rdy"
                :propObjectId="6"
                :propObjectTypeId="6"
                @on-success="fileUploaded"
                class="wd-100p"
                propAccept="image/png, image/jpeg, image/jpg, image/bmp"
              >
                <div slot="trigger" class="wd-100p">
                  <a
                    v-if="
                      profile.defaultAttachmentId == 0 ||
                      profile.defaultAttachmentId == null
                    "
                    class="dropdown-item"
                    >Энд дарж зураг оруулна уу.</a
                  >
                  <div v-else class="d-flex align-items-center pd-5">
                    <div class="avatar avatar-xxl">
                      <img :src="`${avatar.uploadedUrl}`" class="rounded" alt />
                    </div>
                    <div class="mg-l-auto tx-color-03">Зураг солих</div>
                  </div>
                </div>
                <!-- <div v-else slot="content" class="wd-100p">
                                    
                </div>-->
              </simple-uploader>
              <button
                @click="saveImg()"
                v-show="$store.state.app.activeGroup.id != 9157"
                class="btn btn-xs btn-block btn-success"
              >
                Зураг хадгалах
              </button>


              <div v-if="$store.state.app.activeGroup.id == 9301" class="mg-t-20">
                <simple-uploader
                  v-if="rdy"
                  :propObjectId="6"
                  :propObjectTypeId="6"
                  @on-success="fileUploaded1"
                  class="wd-100p"
                  propAccept="image/png, image/jpeg, image/jpg, image/bmp"
                >
                  <div slot="trigger" class="wd-100p">
                    <a
                      v-if="
                        profile.secondAttachmentId == 0 ||
                        profile.secondAttachmentId == null
                      "
                      class="dropdown-item"
                      >Энд дарж зураг оруулна уу.</a
                    >
                    <div v-else class="d-flex align-items-center pd-5">
                      <div class="avatar avatar-xxl">
                        <img :src="`${unemleh.uploadedUrl}`" class="rounded" alt />
                      </div>
                      <div class="mg-l-auto tx-color-03">Зураг солих</div>
                    </div>
                  </div>
                  <!-- <div v-else slot="content" class="wd-100p">
                                      
                  </div>-->
                </simple-uploader>
                <button
                  @click="saveImg()"
                  
                  class="btn btn-xs btn-block btn-success"
                >
                  Үнэмлэх зураг хадгалах
                </button>
              </div>
              <!-- <div class="avatar avatar-xxl"><img    :src="`${$store.state.user.userInfo.avator}`" class="rounded" alt=""></div> -->
            </div>
            <!-- col -->
            <div class="col-sm-8 col-md-7 col-lg mg-t-20 mg-sm-t-0">
              <h5 class="mg-b-2 tx-spacing--1">
                {{ $store.state.user.userInfo.fullName }}
              </h5>
              <p class="tx-color-03 mg-b-0">
                {{ $store.state.user.userInfo.mail }}
              </p>
              <!-- <div class="d-flex mg-b-25">
                        <button class="btn btn-xs btn-white flex-fill">Message</button>
                        <button class="btn btn-xs btn-primary flex-fill mg-l-10">Follow</button>
              </div>-->
            </div>

            <div class="col-sm-6 col-md-5 col-lg" v-if="rdy">
              <label class="tx-14 tx-color-01 tx-spacing-1 mg-b-15"
                >{{ $store.state.user.userInfo.ovog }} овогтой
                {{ $store.state.user.userInfo.ner }}</label
              >
              <ul class="list-group">
                <li class="list-group-item d-flex align-items-center bg-light">
                  <div class="avatar mg-r-10" style="min-width: 40px">
                    <span class="avatar-initial rounded-circle bg-gray-500"
                      >1</span
                    >
                  </div>
                  <div>
                    <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                      {{ profile.loginName }}
                    </h6>
                    <span class="d-block tx-11 text-muted">{{
                      (($store.state.app.activeGroup.id == 9265 || $store.state.app.activeGroup.id == 9254))
                        ? "Нэвтрэх нэр"
                        : "Гишүүний №"
                    }}</span>
                  </div>
                </li>
                <li class="list-group-item d-flex align-items-center bg-light">
                  <div class="avatar mg-r-10" style="min-width: 40px">
                    <span class="avatar-initial rounded-circle bg-gray-500"
                      >2</span
                    >
                  </div>
                  <div>
                    <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                      {{ profile.langCode }}
                    </h6>
                    <span class="d-block tx-11 text-muted">Регистр</span>
                  </div>
                </li>
                <li class="list-group-item d-flex align-items-center bg-light">
                  <div class="avatar mg-r-10" style="min-width: 40px">
                    <span class="avatar-initial rounded-circle bg-gray-500"
                      >3</span
                    >
                  </div>
                  <div>
                    <h6 class="tx-11 tx-inverse tx-semibold mg-b-0">
                      {{ flat1 }}
                    </h6>
                    <span class="d-block tx-11 text-muted">Гишүүний төрөл</span>
                  </div>
                </li>
                <li class="list-group-item d-flex align-items-center bg-light">
                  <div class="avatar mg-r-10" style="min-width: 40px">
                    <span class="avatar-initial rounded-circle bg-gray-500"
                      >4</span
                    >
                  </div>
                  <div>
                    <h6 class="tx-11 tx-inverse tx-semibold mg-b-0">
                      {{ flat2 }}
                    </h6>
                    <span class="d-block tx-11 text-muted">Салбар</span>
                  </div>
                </li>
                <li
                  v-if="
                    $store.state.app.activeGroup.id == 9157 ||
                    $store.state.app.activeGroup.id == 6126
                  "
                  class="list-group-item d-flex align-items-center bg-light"
                >
                  <div class="avatar mg-r-10" style="min-width: 40px">
                    <span class="avatar-initial rounded-circle bg-gray-500"
                      >5</span
                    >
                  </div>
                  <div v-if="$store.state.app.activeGroup.id == 9157">
                    <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                      {{ profile.unit == 1 ? "Тийм" : "Үгүй" }}
                    </h6>
                    <span class="d-block tx-11 text-muted">Аудитор эсэх</span>
                  </div>
                  <div v-else-if="$store.state.app.activeGroup.id == 6126">
                    <!-- <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                      {{ profile.unit == 1 ? "Тийм" : "Үгүй" }}
                    </h6> -->
                    <div
                      @click="profile.unit = profile.unit != 1 ? 1 : 0"
                      class="custom-control custom-switch"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        :checked="profile.unit == 1"
                      />
                      <label class="custom-control-label">Мэргэшсэн нягтлан бодогч эсэх</label
                      >
                    </div>
                    <div>
                      <input
                        v-show="profile.unit == 1"
                        v-model="profile.s6"
                        style="width: 100%"
                        class="form-control form-control-xs"
                        placeHolder="МНБИ №"
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="media-body mg-b-30 pd-lg-x-10">
          <div v-if="rdy">
            <div class="card mg-b-20 mg-lg-b-25">
              <div
                class="
                  card-header
                  pd-y-15 pd-x-20
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <h6 class="tx-uppercase tx-semibold mg-b-0">
                  1. Гишүүний ерөнхий мэдээлэл
                </h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-5">
                    <div class="pd-r-10">
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-5 col-form-label text-right"
                          >Үндэс угсаа</label
                        >
                        <div class="col-sm-7 pd-0-f">
                          <loc-type-cascader
                            :disabled="manager"
                            :id="profile.locTypeId10"
                            v-model="profile.locTypeId10"
                            disableAdd
                            :getParentType="true"
                            locTypekey="sysHrVndesUgsaa"
                            class="wd-100p"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-5 col-form-label text-right"
                          >Ургийн овог</label
                        >
                        <div class="col-sm-7 pd-0-f">
                          <input
                            v-model="profile.st2"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>

                      <div
                        v-if="$store.state.app.activeGroup.id == 9265 || $store.state.app.activeGroup.id == 9254"
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-5 col-form-label text-right"
                          >Эцэг/Эх-н нэр</label
                        >
                        <div class="col-sm-7 pd-0-f">
                          <input
                            v-model="profile.lat"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>

                      <div
                        v-if="$store.state.app.activeGroup.id == 9265 || $store.state.app.activeGroup.id == 9254"
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-5 col-form-label text-right"
                          >Нэр</label
                        >
                        <div class="col-sm-7 pd-0-f">
                          <input
                            v-model="profile.task"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div
                        v-if="$store.state.app.activeGroup.id == 9265 || $store.state.app.activeGroup.id == 9254"
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-5 col-form-label text-right"
                          >Регистр №</label
                        >
                        <div class="col-sm-7 pd-0-f d-flex">
                          <Select
                            v-model="form.userRegA"
                            style="width: 60px"
                            placeholder="А"
                            clearable
                            filterable
                            size="medium"
                          >
                            <Option
                              v-for="(item, i) in crylChars"
                              :label="item.toUpperCase()"
                              :value="item"
                              :key="i + '_regA'"
                              >{{ item.toUpperCase() }}</Option
                            >
                          </Select>
                          <Select
                            v-model="form.userRegB"
                            style="width: 60px"
                            placeholder="Б"
                            clearable
                            filterable
                            size="medium"
                          >
                            <Option
                              v-for="(item, i) in crylChars"
                              :label="item.toUpperCase()"
                              :value="item"
                              :key="i + '_regB'"
                              >{{ item.toUpperCase() }}</Option
                            >
                          </Select>
                          <input
                            v-model="form.userRegister"
                            maxlength="8"
                            type="text"
                            @keypress="validateRegister($event)"
                            class="form-control wd-60p"
                            placeholder="Регистр № оруулна уу"
                          />
                        </div>
                      </div>

                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-5 col-form-label text-right"
                          >Төрсөн</label
                        >
                        <div class="col-sm-7 pd-0-f">
                          <input
                            :disabled="manager"
                            type="date"
                            @change="birthChanged"
                            :value="profile.d1 | moment('YYYY-MM-DD')"
                            style="width: 100%"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-5 col-form-label text-right"
                          >Төрсөн аймаг/сум</label
                        >
                        <div class="col-sm-7 pd-0-f">
                          <loc-type-cascader
                            :disabled="manager"
                            :id="profile.locTypeId2"
                            v-model="profile.locTypeId2"
                            checkStrictly
                            disableAdd
                            locTypekey="sysRefProvince"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-5 col-form-label text-right"
                          >Төрсөн газар</label
                        >
                        <div class="col-sm-7 pd-0-f">
                          <input
                            :disabled="manager"
                            v-model="profile.s2"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-5 col-form-label text-right"
                          >Хүйс</label
                        >
                        <div class="col-sm-7 pd-0-f">
                          <loc-type-cascader
                            disableAdd
                            :id="profile.locTypeId1"
                            v-model="profile.locTypeId1"
                            locTypekey="sysGlobalRefGender"
                          />
                        </div>
                      </div>
                      <template
                        v-if="
                          $store.state.app.activeGroup.id == 9157 ||
                          $store.state.app.activeGroup.id == 6126
                        "
                      >
                        <div
                          class="
                            form-group
                            row
                            d-flex
                            align-items-center
                            mg-b-5
                          "
                        >
                          <label class="col-sm-5 col-form-label text-right"
                            >Одоогийн төлөв</label
                          >
                          <div class="col-sm-7 pd-0-f">
                            <loc-type-cascader
                              disableAdd
                              :id="profile.locTypeId14"
                              v-model="profile.locTypeId14"
                              locTypekey="mmberAjilErhlelt"
                            />
                          </div>
                        </div>
                        <div
                          class="
                            form-group
                            row
                            d-flex
                            align-items-center
                            mg-b-5
                          "
                        >
                          <label class="col-sm-5 col-form-label text-right"
                            >Мэргэшиж буй салбар</label
                          >
                          <div class="col-sm-7 pd-0-f">
                            <loc-type-cascader
                              disableAdd
                              :id="profile.locTypeId9"
                              v-model="profile.locTypeId9"
                              locTypekey="mmbrWorkSalbar"
                            />
                          </div>
                        </div>
                        <div
                          v-if="$store.state.app.activeGroup.id == 9157"
                          class="
                            form-group
                            row
                            d-flex
                            align-items-center
                            mg-b-0
                          "
                        >
                          <label class="col-sm-5 col-form-label text-right"
                            >Ажил хайж байгаа эсэх</label
                          >
                          <div class="col-sm-7 pd-0-f">
                            <loc-type-cascader
                              :disabled="manager"
                              disableAdd
                              :id="profile.locTypeId15"
                              v-model="profile.locTypeId15"
                              locTypekey="mmberAjilHailt"
                            />
                          </div>
                        </div>
                      </template>
                      <!-- || $store.state.app.activeGroup.id == 9254 -->
                      <template v-if="($store.state.app.activeGroup.id == 9265 || $store.state.app.activeGroup.id == 9301 )">
                        <div class="form-group row d-flex align-items-center mg-b-5">
                          <label class="col-sm-5 col-form-label text-right">Байгууллага</label>
                          <div class="col-sm-7 pd-0-f">
                            <Select v-model="profile.departId" @change="departChanged" class="wd-100p" clearable>
                              <Option
                                v-for="(d, i) in departs"
                                :key="i"
                                :value="d.id"
                                :label="d.label"
                              ></Option>
                            </Select>
                          </div>
                        </div>
                        <div v-if="dpOther" class="form-group row d-flex align-items-center mg-b-5">
                          <label class="col-sm-5 col-form-label text-right">Одоо ажиллаж буй ажлын газрын нэр</label>
                          <div class="col-sm-7 pd-0-f">
                            <input
                              v-model="profile.s6"
                              type="text"
                              class="form-control"
                              placeholder="Одоо ажиллаж буй ажлын газрын нэр бичнэ үү"
                            />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center mg-b-5">
                          <label class="col-sm-5 col-form-label text-right">Газар/Хэлтэс/Алба</label>
                          <div class="col-sm-7 pd-0-f">
                            <input
                              v-model="profile.s7"
                              type="text"
                              class="form-control"
                              placeholder="Газар / Хэлтэс / Алба"
                            />
                          </div>
                        </div>
                      </template>
                      <div v-if="showTempDepart()" class="form-group row d-flex align-items-center mg-b-5">
                          <label class="col-sm-5 col-form-label text-right">Харьяалал</label>
                          <div class="col-sm-7 pd-0-f">
                            <depart-cascader v-model="profile.departId" :id="profile.departId" ></depart-cascader>
                            <!-- <Select v-model="profile.departId" @change="departChanged" class="wd-100p" clearable>
                              <Option
                                v-for="(d, i) in departs"
                                :key="i"
                                :value="d.id"
                                :label="d.label"
                              ></Option>
                            </Select> -->
                          </div>
                        </div>

                      <div v-if="$store.state.app.activeGroup.id != 9254"
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-5 col-form-label text-right"
                          >Ажил, албан тушаал</label
                        >
                        <div class="col-sm-7 pd-0-f">
                          <input
                            :disabled="manager"
                            type="text"
                            v-model="profile.position"
                            style="width: 100%"
                            class="form-control"
                            maxlength="450"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-7 bd-l">
                    <div class="pd-r-10">
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-4 col-form-label text-right"
                          >Утас 1</label
                        >
                        <div class="col-sm-8 pd-0-f">
                          <div class="d-flex align-items-center">
                            <input
                              v-model="profile.mobile"
                              type="text"
                              class="form-control"
                            />
                            <label
                              class="
                                pd-x-10
                                d-flex
                                align-items-center
                                text-right
                              "
                              style="width: 40%"
                              >Утас 2</label
                            >
                            <input
                              v-model="profile.prefix"
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-4 col-form-label text-right"
                          >Сошиал хаяг</label
                        >
                        <div class="col-sm-8 pd-0-f">
                          <input
                            v-model="profile.taskEn"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-4 col-form-label text-right"
                          >Оршин суугаа хаяг</label
                        >
                        <div class="col-sm-8 pd-0-f">
                          <input
                            :disabled="manager"
                            v-model="profile.s1"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="divider-text">
                        Шаардлагатай үед холбоо барих хүний мэдээлэл
                      </div>
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-4 col-form-label text-right"
                          >Нэр</label
                        >
                        <div class="col-sm-8 pd-0-f">
                          <input
                            :disabled="manager"
                            v-model="profile.st3"
                            type="text"
                            class="form-control form-control-sm"
                            maxlength="50"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-4 col-form-label text-right"
                          >Утас</label
                        >
                        <div class="col-sm-8 pd-0-f">
                          <input
                            :disabled="manager"
                            v-model="profile.st4"
                            type="text"
                            class="form-control form-control-sm"
                            maxlength="50"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-4 col-form-label text-right"
                          >Хаяг</label
                        >
                        <div class="col-sm-8 pd-0-f">
                          <input
                            :disabled="manager"
                            v-model="profile.latStrVw"
                            type="text"
                            class="form-control form-control-sm"
                            maxlength="50"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row d-flex align-items-center mg-b-5"
                      >
                        <label class="col-sm-4 col-form-label text-right"
                          >Таны хэн болох</label
                        >
                        <div class="col-sm-8 pd-0-f">
                          <input
                            :disabled="manager"
                            v-model="profile.lngStrVw"
                            type="text"
                            class="form-control form-control-sm"
                            maxlength="50"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer bg-transparent pd-y-15 pd-x-20">
                <button @click="saveData()" class="btn btn-block btn-success">
                  Хадгалах
                </button>
              </div>
            </div>
          </div>

          <div v-for="(b, i) in profile.b" :key="i">
            <div class="card mg-b-20 mg-lg-b-25">
              <div
                class="
                  card-header
                  pd-y-15 pd-x-20
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <h6 class="tx-uppercase tx-semibold mg-b-0">
                  {{ i + 2 }}. {{ b.nm }}
                </h6>
                <nav class="nav nav-with-icon tx-13 mg-l-20">
                  <!-- style="min-width: 240px" -->
                  <!-- <a @click="openAdd(b)" class="nav-link" role="button"><feather type="edit" class="mg-r-5 ht-20-f wd-20-f"></feather> Засах</a>
                  <a @click="openAdd(b)" class="nav-link" role="button"><feather type="trash-2" class="mg-r-5 ht-20-f wd-20-f"></feather> Устгах</a>-->
                  <a @click="openAdd(b)" class="nav-link" role="button">
                    <feather
                      type="plus"
                      class="mg-r-5 ht-20-f wd-20-f"
                    ></feather
                    >Нэмэх
                  </a>
                </nav>
              </div>
              <!-- card-header -->
              <div class="card-body pd-0">
                <loader
                  :ref="`ldr_box_${b.id}`"
                  :box="b"
                  :prms="{ boxChooser: false }"
                  :detailSettingProp="{
                    boxSetting: {
                      listSetting: { height: 0 },
                      hideToolbar: true,
                      hideEmptyTemplate: true,
                      autoHeight: true,
                    },
                  }"
                  @on-detail="showDetail"
                  @load-box="loadBoxData"
                />
                <!-- @show-edit="editShow($event)"
                            @box-edit="editBox"
                            @box-delete="deleteBoxConfirm"
                            @on-detail="showDetail"
                            @on-attach="showFile($event)"
                            @load-box="loadBoxData"
                            @update-box-count="b.attachCount = $event.count; b.formCount = $event.count;"
                            @box-loaded="boxLoading=false;"
                            @on-reload-parent="init($event)"
                @on-exam-report="onExamReport"-->
              </div>
              <div class="card-footer bg-transparent pd-y-15 pd-x-20 d-none">
                <nav class="nav nav-with-icon tx-13">
                  <a href class="nav-link">
                    Show More Education (2)
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-down mg-l-2 mg-r-0 mg-t-2"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </a>
                </nav>
              </div>
              <!-- card-footer -->
            </div>
          </div>
        </div>

        <div class="profile-sidebar mg-t-40 mg-lg-t-0 pd-lg-l-25 d-none">
          <div class="row">
            <div class="col-sm-6 col-md-5 col-lg">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  mg-b-20
                "
              >
                <h6 class="tx-13 tx-spacng-1 tx-uppercase tx-semibold mg-b-0">
                  Stories
                </h6>
                <a href class="link-03">Watch All</a>
              </div>
              <ul class="list-unstyled media-list mg-b-15">
                <li class="media align-items-center">
                  <a href>
                    <div class="avatar avatar-online">
                      <span class="avatar-initial rounded-circle bg-gray-50"
                        >S</span
                      >
                    </div>
                  </a>
                  <div class="media-body pd-l-15">
                    <p class="tx-medium mg-b-0">
                      <a href class="link-01">Socrates Itumay</a>
                    </p>
                    <span class="tx-12 tx-color-03">2 hours ago</span>
                  </div>
                </li>
                <li class="media align-items-center">
                  <a href>
                    <div class="avatar avatar-online">
                      <span class="avatar-initial rounded-circle bg-primary"
                        >I</span
                      >
                    </div>
                  </a>
                  <div class="media-body pd-l-15">
                    <p class="tx-medium mg-b-0">
                      <a href class="link-01">Isidore Dilao</a>
                    </p>
                    <span class="tx-12 tx-color-03">5 hours ago</span>
                  </div>
                </li>
                <li class="media align-items-center">
                  <a href>
                    <div class="avatar avatar-online">
                      <span class="avatar-initial rounded-circle bg-info"
                        >K</span
                      >
                    </div>
                  </a>
                  <div class="media-body pd-l-15">
                    <p class="tx-medium mg-b-0">
                      <a href class="link-01">Kirby Avendula</a>
                    </p>
                    <span class="tx-12 tx-color-03">2 days ago</span>
                  </div>
                </li>
                <li class="media align-items-center">
                  <a href>
                    <div class="avatar avatar-online">
                      <span class="avatar-initial rounded-circle bg-gray-50"
                        >S</span
                      >
                    </div>
                  </a>
                  <div class="media-body pd-l-15">
                    <p class="tx-medium mg-b-0">
                      <a href class="link-01">Socrates Itumay</a>
                    </p>
                    <span class="tx-12 tx-color-03">2 hours ago</span>
                  </div>
                </li>
              </ul>
              <a href class="link-03 d-inline-flex align-items-center">
                See more stories
                <i class="icon ion-ios-arrow-down mg-l-5 mg-t-3 tx-12"></i>
              </a>
            </div>

            <!-- col -->
          </div>
        </div>
      </div>
    </div>

    <task-edit
      :prms.sync="taskEdit"
      :show.sync="taskEdit.show"
      :disablePreEditCheck="true"
      @on-task-posted="taskPosted"
      @on-edit-close="editClosed"
    ></task-edit>

    <task-detail-side
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      propWidth="50%"
      @on-task-detail="showDetail"
      @on-task-delete="taskDeleted"
      @on-task-reload="taskUpdated"
      @on-task-close="taskDialogSide.id = 0"
      :detailSettingProp="{
        hideMainMenu: true,
        showMiniMenu: true,
        hideExecution: true,
        hideProcess: true,
      }"
    ></task-detail-side>
    <!--  -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import loader from "@/components/box/loader/loader.vue";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { Notification, Select, Option, Message } from "element-ui";

import { isValidMobile } from "@/libs/tools";

import { mapActions } from "vuex";
const moment = require("moment");
 
export default {
  components: {
    loader,
    Notification,
    Select,
    Option,
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    manager: {
      type: Boolean,
      default: () => false,
    },
    propId: {
      type: Number,
      default: () => 0,
    },
  },
  mounted() {
    this.toggleBodyClass("addClass", "page-profile");
    require("@/assets/scss/pages/profile.scss");
    this.init();
    //console.log('step 1', this.$store.state.app.activeGroup.id);
    if (this.$store.state.app.activeGroup.id == 9265 || this.$store.state.app.activeGroup.id == 9301 || this.$store.state.app.activeGroup.id == 9254
    || this.$store.state.app.activeGroup.id == 6126
    ) {
      //console.log('stp 11');
      this.initDeparts();
    }
  },
  beforeDestroy() {
    //window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "page-profile");
  },
  destroyed() {
    //window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "page-profile");
  },
  data() {
    return {
      departs: [],
      dpOther: false,

      profile: {
        b: [],
      },
      rdy: false,
      hrm: {},
      id: 0,
      taskEdit: {
        id: 0,
        boxId: 0,
        show: false,
        render: false,
        objectTypeId: 0,
        projectId: 0,
        parentId: 0,
      },
      taskDialogSide: {
        show: false,
        id: 0,
        boxId: 0,
        key: 0,
      },
      avatar: {
        uploadedUrl: "",
      },
      unemleh: {
        uploadedUrl: "",
      },
      flat1: "",
      flat2: "",
      form: {
        userRegA: "",
        userRegB: "",
        userRegister: "",
      },
      crylChars: [
        "а",
        "б",
        "в",
        "г",
        "д",
        "е",
        "ё",
        "ж",
        "з",
        "и",
        "й",
        "к",
        "л",
        "м",
        "н",
        "о",
        "п",
        "р",
        "с",
        "т",
        "у",
        "ф",
        "х",
        "ц",
        "ч",
        "ш",
        "щ",
        "ъ",
        "ы",
        "ь",
        "э",
        "ю",
        "я",
      ],
    };
  },
  methods: {
    ...mapActions(["handleUserInfo", "handleLoading"]),
    showTempDepart(){
      let rv= false;
      if(this.$store.state.app.activeGroup.id == 6126 && this.isDateBefore('2023.11.07 23:59:59', new Date())){
        rv= true;
      }
      return rv;
    },
    isDateBefore(d1, d2) {
      // console.log(moment(d2).isBefore(d1), moment(d1), d2);
      return moment(d2).isBefore(d1);
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    initDeparts() {
      //console.log('stp 12');
      this.handleLoading({ isLoading: true });

      //console.log('stp 13');
      let _pid= null;
      if(this.$store.state.app.activeGroup.id == 9265){
        _pid= 19875;
      }else if(this.$store.state.app.activeGroup.id == 9254){
        _pid= 18372;
      }else if(this.$store.state.app.activeGroup.id == 9301){
        _pid= 26902;
      }else if(this.$store.state.app.activeGroup.id == 6126){
        _pid= 12416;//15467;
      }
      //console.log('stp 14');
      //console.log('step 3');
      request({
        api: { method: "GET", url: "hr/getDepartTreeData" },
        params: { 
          parentId: _pid,
          geChild: false
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.departs = res.data.departs;
          //console.log('step 2', this.departs);
        }
      });
    },
    departChanged(e) {
      let _dt = this.departs.filter((x) => x.id == e);
      if (_dt.length && _dt[0]["shortName"] == "other") {
        this.dpOther = true;
      } else {
        this.dpOther = false;
      }
    },
    init() {
      let _pid = 0;
      let prj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == parseInt(138, 10)
      );
      if (prj.length > 0) _pid = prj[0].id;
      //console.log('get inherited', _pid, this.$store.state.user.userInfo.profileId);
      let _uid = 0;
      if (this.manager) {
        _uid = this.propId;
      } else {
        if (this.id > 0) {
          _uid = this.id;
        } else {
          _uid = this.$store.state.user.userInfo.profileId;
        }
      }
      //console.log('_uid', _uid);
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: _uid,
          objectTypeId: 138,
          parentId: 0,
          projectId: _pid,
          boxId: 0,
          userId: this.$store.state.user.userInfo.userId,
        },
        store: this.$store,
      }).then((res) => {
        //console.log('get inherited', res);
        this.profile = res.data.task;
        //this.profileUID = res.data.task.userId;
        //console.log('this.profile.id', this.profile.id);
        request({
          api: { method: "GET", url: "task/taskInheritedDetail" },
          params: { id: this.profile.id },
          store: this.$store,
        }).then((res) => {
          this.profile = res.data.task;
          if (this.profile.langCode != null) {
            if (this.profile.langCode.length > 0)
              this.form.userRegA = this.profile.langCode.substring(0, 1);
            if (this.profile.langCode.length > 1)
              this.form.userRegB = this.profile.langCode.substring(1, 2);
            //console.log(this.form.userRegB);
            if (this.profile.langCode.length > 2)
              this.form.userRegister = this.profile.langCode.substring(
                2,
                this.profile.langCode.length
              );
          }

          this.avatar.uploadedUrl = this.$store.state.user.userInfo.avator;
          this.unemleh.uploadedUrl= this.profile.secondAttachmentUrl;

          this.getLocTypeDisplayString(this.profile.locTypeId4);
          this.getDepartDisplayString(this.profile.departId);

          this.$nextTick(() => {
            this.rdy = true;
          });

          // this.profile.b.filter(x =>{
          //     if(this.profile.unit==1 && (x.ot==141 || x.ot==142 || x.ot==311 || x.ot==149 || x.ot==316)){
          //       console.log(x.nm)
          //     }
          //   }
          // );

          // this.ready = true;

          if (this.manager) {
            this.profile.b = this.profile.b.filter((x) => x.ot == 140);
          } else if (this.$store.state.app.activeGroup.id == 6126) {
            this.profile.unit = this.profile.unit == 1 ? 1 : 0;
            //console.log("this.profile.unit", this.profile.unit);
            // console.log('this.profile.b', res.data.task.b.map(x=>{
            //   return x.ot+'.'+x.nm
            // }));
            this.profile.b = this.profile.b.filter(
              (x) =>
                x.ot == 139 ||
                x.ot == 140 ||
                x.ot == 377 ||
                x.ot == 151 ||
                x.ot == 148 ||
                x.ot == 454 ||
                x.ot == 455 ||
                x.ot == 456 ||
                //(this.profile.unit == 1 && (
                x.ot == 141 ||
                x.ot == 142 ||
                x.ot == 311 ||
                x.ot == 149 ||
                x.ot == 316
              //))
            );

            if (this.profile.b.filter((x) => x.ot == 149).length) {
              this.profile.b.filter((x) => x.ot == 149)[0]["nm"] =
                "Мэргэшлийн бэлтгэл (Мэргэжлээрээ болон бусад чиглэлээр нарийн  мэргэшүүлэх  сургалтад  хамрагдсан  байдлыг  бичнэ)";
            }
          } else {
            this.profile.b = this.profile.b.filter(
              (x) =>
                x.ot == 139 ||
                x.ot == 140 ||
                x.ot == 377 ||
                x.ot == 151 ||
                x.ot == 148 ||
                x.ot == 454 ||
                x.ot == 455 ||
                x.ot == 456 ||
                x.ot == 141 ||
                x.ot == 142 ||
                x.ot == 311 ||
                x.ot == 149 ||
                x.ot == 316
              // (this.profile.unit == 1 &&
              //   (x.ot == 141 ||
              //     x.ot == 142 ||
              //     x.ot == 311 ||
              //     x.ot == 149 ||
              //     x.ot == 316)
              //     )
            );
          }
        });

        // getUserAvator({
        // userId: this.profile.userId,
        // w: 160,
        // h: 160,
        // mode: "crop"
        // }).then(res => {
        // this.profileUImg = res.data.avator;
        // });
        // GetDepartTreeData().then(res => {
        // let fdeparts = res.data.departs;

        // var ltt = new LTT(fdeparts, {
        //     key_id: "id",
        //     key_parent: "parentId",
        //     key_child: "children"
        // });

        // this.departs = ltt.GetTree();

        // if (this.profile.departId != null) {
        //     this.departRecursive(fdeparts, this.profile.departId);
        //     this.departIDSelected = this.departSelArr.reverse();
        // }
        // });
      });
    },

    getLocTypeDisplayString(id) {
      //return id;
      request({
        api: { method: "GET", url: "type/GetFlatType" },
        params: { id: id, sep: " / " },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.flat1 = res.data.flatted;
        }
      });
    },
    getDepartDisplayString(id) {
      request({
        api: { method: "GET", url: "hr/GetFlatDepart" },
        params: { id: id, sep: " / " },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.flat2 = res.data.flatted;
        }
      });
    },

    birthChanged(e) {
      this.profile.d1 = e.target.value;
    },
    openAdd(b) {
      //console.log(b);
      this.taskEdit.id = 0;
      this.taskEdit.boxId = b.id;
      this.taskEdit.objectTypeId = b.ot;
      this.taskEdit.projectId = b.projectId;
      this.taskEdit.parentId = this.profile.id;
      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    taskPosted(e) {
      //this.$refs[`ldr_box_${e.prms.boxId}`][0].init();
      this.$refs[`ldr_box_${e.prms.boxId}`][0].reInit();
      this.editClosed();
    },
    taskDeleted() {
      this.$refs[`ldr_box_${this.taskDialogSide.boxId}`][0].reInit();
      this.editClosed();
    },
    taskUpdated() {
      this.taskDialogSide.id = 0;
      this.$refs[`ldr_box_${this.taskDialogSide.boxId}`][0].reInit();
    },
    editClosed() {
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    validateRegister(event) {
      if (event.charCode >= 48 && event.charCode <= 57) return true;
      else event.preventDefault();
    },
    saveData() {
      if (this.$store.state.app.activeGroup.id == 9265 || this.$store.state.app.activeGroup.id == 9254) {
        //BFA
        if (this.form.userRegA == "") {
          Message({
            message: "Регистрийн дугаарын эхний үсгийг оруулна уу",
            type: "warning",
          });
          return false;
        } else if (this.form.userRegB == "") {
          Message({
            message: "Регистрийн дугаарын 2 дахь үсгийг оруулна уу",
            type: "warning",
          });
          return false;
        } else if (
          this.form.userRegister == "" ||
          this.form.userRegister.length < 8
        ) {
          Message({
            message: "Регистрийн дугаарын 8 оронг оруулна уу",
            type: "warning",
          });
          return false;
        }

        this.profile.langCode =
          this.form.userRegA.toUpperCase() +
          this.form.userRegB.toUpperCase() +
          this.form.userRegister;
      }

      let errs = [];
      if (
        this.profile.defaultAttachmentId == null ||
        this.profile.defaultAttachmentId == 0
      ) {
        errs.push("Зураг оруулаагүй байна.");
      }

      if (this.$store.state.app.activeGroup.id == 9265 || this.$store.state.app.activeGroup.id == 9254) {
        if (this.profile.task == null || this.profile.task.length <= 0) {
          errs.push("Нэр бичнэ үү !");
        }
      }

      if (this.$store.state.app.activeGroup.id == 9301) {
        if (this.profile.secondAttachmentId == null || this.profile.secondAttachmentId == 0) {
          errs.push("Үнэмлэх зураг оруулна уу !");
        }

        if (this.profile.departId == null || this.profile.departId == 0) {
          errs.push("Байгууллага сонгоно уу !");
        }
      }

      if (
        this.profile.locTypeId1 == null ||
        this.profile.locTypeId1.length <= 0
      ) {
        errs.push("Хүйс сонгоно уу !");
      }

      if (
        (this.$store.state.app.activeGroup.id == 9157 ||
          this.$store.state.app.activeGroup.id == 6126) &&
        (this.profile.locTypeId14 == null ||
          this.profile.locTypeId14.length <= 0)
      ) {
        errs.push("Одоогийн төлөв сонгоно уу !");
      }
      if (
        (this.$store.state.app.activeGroup.id == 9157 ||
          this.$store.state.app.activeGroup.id == 6126) &&
        (this.profile.locTypeId9 == null || this.profile.locTypeId9.length <= 0)
      ) {
        errs.push("Мэргэшиж буй салбар сонгоно уу !");
      }
      if (
        this.$store.state.app.activeGroup.id == 9157 &&
        (this.profile.locTypeId15 == null ||
          this.profile.locTypeId15.length <= 0)
      ) {
        errs.push("Ажил хайж байгаа эсэх сонгоно уу !");
      }
      if (!isValidMobile(this.profile.mobile)) {
        errs.push("Утас 1 формат буруу байна.");
      }
      if (this.$store.state.app.activeGroup.id != 9265 && this.$store.state.app.activeGroup.id != 9254 && this.$store.state.app.activeGroup.id != 9301) {
        if (!isValidMobile(this.profile.prefix)) {
          errs.push("Утас 2 формат буруу байна.");
        }
      }
      if (this.$store.state.app.activeGroup.id != 9265 && this.$store.state.app.activeGroup.id != 9254 && this.$store.state.app.activeGroup.id != 9301) {
        if (this.profile.taskEn == null || this.profile.taskEn.length <= 0) {
          errs.push("Сошиал хаяг бичнэ үү !");
        }
      }
      //   if(this.profile.locTypeId13 == null || this.profile.locTypeId13.length <= 0){
      //     errs.push("Оршин суугаа хаяг сонгоно уу !");
      //   }
      if (this.$store.state.app.activeGroup.id != 9265 && this.$store.state.app.activeGroup.id != 9254 && this.$store.state.app.activeGroup.id != 9301) {
        if (this.profile.s1 == null || this.profile.s1.length <= 0) {
          errs.push("Оршин суугаа хаяг бичнэ үү !");
        }
      }

      if (this.$store.state.app.activeGroup.id == 9157) {
        if (this.profile.st3 == null || this.profile.st3.length <= 0) {
          errs.push("Шаардлагатай үед холбоо барих хүний нэр бичнэ үү !");
        }
        if (this.profile.st4 == null || this.profile.st4.length <= 0) {
          errs.push("Шаардлагатай үед холбоо барих хүний утас бичнэ үү !");
        }
        if (
          this.profile.latStrVw == null ||
          this.profile.latStrVw.length <= 0
        ) {
          errs.push("Шаардлагатай үед холбоо барих хүний хаяг бичнэ үү !");
        }
        if (
          this.profile.lngStrVw == null ||
          this.profile.lngStrVw.length <= 0
        ) {
          errs.push(
            "Шаардлагатай үед холбоо барих хүний таны хэн болох бичнэ үү !"
          );
        }
      }

      //   if(this.profile.s16 == null || this.profile.s16.length <= 0){
      //     errs.push("Mэдээлэл авдаг суваг эх үүсвэр сонгоно уу !");
      //   }

      //   if(!this.dataIsFilled){
      //     errs.push("Мэдээлэл бүрэн зөв бөглөсөн сонголтыг сонгоно уу !");
      //   }

      if (errs.length == 0 || this.manager) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Task/PostInherited" },
          data: { model: this.profile },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.handleUserInfo({ store: this.$store }).then(x=>{
              Notification.success({
                title: "Амжилттай",
                message: `Мэдээлэл шинэчиллээ`,
                duration: 30000,
                position: "bottom-left",
              });
              if (this.$store.state.app.activeGroup.id == 9157 || this.$store.state.app.activeGroup.id == 9301) {
                this.$router.push({ name: "lmsParticipant" });
              }
            });
          }
        });
        //console.log('profile', this.profile.b.map(x=>x.taskCount));
        // PostInheritedTask({ model: this.profile }).then(res => {
        // if (res.result == 1) {
        //     Object.assign(this.$data, this.$options.data());
        //     this.$Notice.success({ title: "Амжилттай" });
        //     this.$emit("on-success");
        //     //this.handleSysAnket({id :0, isShow: false });
        // }
        // });
      } else {
        Notification.warning({
          title: "Мэдэгдэл",
          message: `${errs[0]}`,
          duration: 5000,
          position: "bottom-left",
        });
      }
    },
    saveImg() {
      let errs = [];
      if (
        this.profile.defaultAttachmentId == null ||
        this.profile.defaultAttachmentId == 0
      ) {
        errs.push("Зураг оруулаагүй байна.");
      }

      if (errs.length == 0 || this.manager) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Task/PostInherited" },
          data: { model: this.profile },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.handleUserInfo({ store: this.$store });
            //console.log('get inherited', res);
            Notification.success({
              title: "Амжилттай",
              message: `Мэдээлэл шинэчиллээ`,
              duration: 30000,
              position: "bottom-left",
            });
            // if (this.$store.state.app.activeGroup.id == 9157) {
            //   this.$router.push({ name: "lmsParticipant" });
            // }
          }
        });
      } else {
        Notification.warning({
          title: "Мэдэгдэл",
          message: `${errs[0]}`,
          duration: 5000,
          position: "bottom-left",
        });
      }
    },
    showDetail(e) {
      //console.log('showDetail', e);
      this.taskDialogSide.boxId = e.boxId;
      this.taskDialogSide.id = e.id;
    },
    loadBoxData(e) {
      //console.log('loadBoxData', e);
    },
    fileUploaded(e) {
      this.avatar.uploadedUrl = e.uploadedUrl;
      this.profile.defaultAttachmentId = e.uploadedAttachmentId;
    },

    fileUploaded1(e) {
      this.unemleh.uploadedUrl = e.uploadedUrl;
      this.profile.secondAttachmentId = e.uploadedAttachmentId;
    },
  },
};
</script>

<style></style>
